import React from 'react';

export const Footer = () => (
  <div className="footer">
    <div>© 2017 <a href="https://github.com/uuzaix/">Larisa Dolgova</a></div>
    <div><a href="https://github.com/uuzaix/predictions">GitHub</a></div>
    <div><a href="https://80000hours.org/2013/05/estimation-part-i-how-to-do-it/">Read about calibration</a></div>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Footer.js